var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FolderTagPreview',{attrs:{"id":_vm.item.injected.fileid,"name":_vm.item.injected.basename.toString(),"path":_vm.item.injected.filename,"file-list":_vm.previewFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }